import { CHOOSE_GROUP_SLUG } from './actionTypes';

export const ChooseGroupSlug = slug => dispatch => {
  dispatch({ type: CHOOSE_GROUP_SLUG, payload: slug });
};



// WEBPACK FOOTER //
// ./src/actions/SlugAction.js